'use client';

import { colors } from '../Utils/constants.js';

// Gap between text and bar in top (in Pixel)
var DEFAULT_BAR_TEXT_GAP_TOP = 5;
// Gap between text value and bar in bottom (in Pixel)
var DEFAULT_BAR_TEXT_GAP_BOTTOM = 6;
// Default border radius (in Pixel)
var DEFAULT_BORDER_RADIUS = 4;
// Default Padding spacing of top/bottom of chart
var DEFAULT_HEIGHT_PADDING = 16;
// Additional height of chart
var ADDITION_HEIGHT = DEFAULT_HEIGHT_PADDING * 2 + DEFAULT_BAR_TEXT_GAP_BOTTOM * 2 + 32;
// Max percent
var DEFAULT_MAX_PERCENT = 100;
// Animation duration
var ANIMATION_DURATION = '0.5s';
// Default top text label font size (used for calculate position when chart is horizontal)
var DEFAULT_FONT_SIZE = 14;
var DEFAULT_STYLE_OPTIONS = {
    barColor: '#4083FF',
    labelColor: '#001744',
    gridColor: '#bcd2fa',
    barWidth: 30,
    barHeight: 300,
    lineCount: 6,
    topPadding: 32,
    leftPadding: 16,
    rightPadding: 0,
    bottomPadding: 0,
    labelFontWeight: 400,
    highlightFontWeight: 700,
    mobileFontSize: 10,
    desktopFontSize: 14,
    barBackgroundColor: '',
    isShowWhenBarZero: true,
    strokeDasharray: {
        width: 4,
        spacing: 4
    },
    isRotateBottomText: false,
    bottomBarTextFontSize: 14,
    isShowBarText: true,
    renderYAxisText: function () { return ''; },
    highlightColor: colors.successColor
};
// Default text options
var DEFAULT_TEXT_OPTIONS = {
    yAxisText: '(Y)',
    xAxisText: '(X)',
    tooltipText: '',
    xAxisPosition: 'end',
    highlightText: 'You are here',
    topLabelPostfixText: '%',
    tooltipDisplayValues: []
};
// Default bar chart options
var DEFAULT_OPTIONS = {
    isHorizontal: false
};

export { ADDITION_HEIGHT, ANIMATION_DURATION, DEFAULT_BAR_TEXT_GAP_BOTTOM, DEFAULT_BAR_TEXT_GAP_TOP, DEFAULT_BORDER_RADIUS, DEFAULT_FONT_SIZE, DEFAULT_HEIGHT_PADDING, DEFAULT_MAX_PERCENT, DEFAULT_OPTIONS, DEFAULT_STYLE_OPTIONS, DEFAULT_TEXT_OPTIONS };
//# sourceMappingURL=constants.js.map
